import React from "react";
import { useWorldContract } from "../../../mud/useWorldContract";
import { Severity } from "@eveworld/types";
import setBringOnline from "../../systemCalls/handleBringOnline";
import { EveButton } from "@eveworld/ui-components";
import { useNotification } from "@eveworld/contexts";

interface ButtonProps {
  AssemblyId: string;
}

const ButtonBringOnline: React.FC<ButtonProps> = ({ AssemblyId }) => {
  const { worldContract } = useWorldContract();
  const { notify } = useNotification();

  const handleBringOnline = async (SmartObjectId: string) => {
    const txHash = await setBringOnline({
      worldContract,
      smartObjectId: SmartObjectId,
    });
    if (txHash) {
      notify({ type: Severity.Success, txHash });
    } else {
      notify({
        type: Severity.Error,
        message: "Transaction failed to execute",
      });
    }
  };

  return (
    <EveButton
      typeClass="primary"
      onClick={() => handleBringOnline(AssemblyId)}
    >
      Bring Online
    </EveButton>
  );
};

export default React.memo(ButtonBringOnline);
